import { SignIn, SignUp } from "@clerk/clerk-react";
import { useClerkAvailable } from "../clerk-context.js";

interface AuthPageProps {
  mode: "sign-in" | "sign-up";
}

const clerkAppearance = {
  elements: {
    rootBox: "mx-auto",
    card: "kin-surface rounded-3xl shadow-none border-0",
    headerTitle: "font-serif text-2xl font-bold text-kin-black",
    headerSubtitle: "text-kin-muted",
    formButtonPrimary: "bg-kin-black hover:bg-kin-black-light rounded-full text-sm font-semibold",
    formFieldInput: "rounded-xl border-kin-olive/20 bg-kin-white/60 focus:border-kin-green text-sm",
    footerActionLink: "text-kin-green-dark font-medium",
  },
};

export function AuthPage({ mode }: AuthPageProps) {
  const clerkAvailable = useClerkAvailable();

  if (!clerkAvailable) {
    return (
      <div className="flex min-h-[70vh] items-center justify-center px-6 py-16">
        <p className="text-sm text-kin-muted">Authentication is not configured.</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-6 py-16">
      {mode === "sign-in" ? (
        <SignIn
          routing="path"
          path="/sign-in"
          signUpUrl="/sign-up"
          fallbackRedirectUrl="/dashboard"
          appearance={clerkAppearance}
        />
      ) : (
        <SignUp
          routing="path"
          path="/sign-up"
          signInUrl="/sign-in"
          fallbackRedirectUrl="/dashboard"
          appearance={clerkAppearance}
        />
      )}
    </div>
  );
}
